import React from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import OutsideClickHandler from 'react-outside-click-handler';
import './style.scss';
import { Button, Icon } from '../../../components';
import { changeActiveTest, closeModal, editTest, openModal } from '../../../redux/actions';
import colors from '../../../utils/colors';
import testImg from '../../../assets/images/test.png';
import DeleteTestModalLayout from '../../Modal/layouts/DeleteTest';

function SingleTest({ test, active, onClick, handleDelete }) {
	const dispatch = useDispatch();

	const handleEditTest = () => {
		dispatch(editTest(test));
	};

	const handleClickAway = (e) => {
		if (active) {
			if (
				![...document.querySelectorAll('.mytests-item')].some((item) => item.contains(e.target)) &&
				!document.querySelector('.module-editor').contains(e.target) &&
				!document.querySelector('.modal-box')
			) {
				dispatch(changeActiveTest(null));
			}
		}
	};

	const handleDeleteTest = () => {
		handleDelete(test['id_testu']);
		dispatch(closeModal());
	};

	const openDeleteTestModal = () => {
		dispatch(openModal(<DeleteTestModalLayout test={test} onDelete={handleDeleteTest} />, false));
	};

	return (
		<OutsideClickHandler onOutsideClick={handleClickAway}>
			<div className={`mytests-item ${active ? 'active' : ''}`} onClick={() => onClick(test.id)}>
				<div className="mytests-item-icon">
					<img src={testImg} alt="" />
					<span className="mytests-item-tasks-count">{test['liczba_pytan']}</span>
				</div>
				<div className="mytests-item-body">
					<div className="mytests-item-body-row">
						<h5>{test.nazwa}</h5>
						<span className="mytests-item-added">
							{moment.unix(test.dataUnix).format('DD.MM.YYYY')}
						</span>
					</div>
					<div className="mytests-item-body-row">
						<p className="mytests-item-subject">{test.przedmiot}</p>
						<div className="test-buttons">
							<Button color="transparent text-primary" onClick={handleEditTest}>
								<span>Edytuj test</span>
								<Icon name="pencil" width="12px" height="12px" color={colors.green} />
							</Button>
							<Button color="delete text-white" className="delete" onClick={openDeleteTestModal}>
								<Icon name="trash" width="12px" height="12px" color={colors.white} />
							</Button>
						</div>
					</div>
				</div>
			</div>
		</OutsideClickHandler>
	);
}

export default SingleTest;
